<template>
<div>
	<div class="form-group row" v-for="item in qtdCs" :key="item">
		<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">{{categoria['c' + item]}}</label>
		<div class="col-sm-10">
			<textarea   class="form-control form-control-sm" type="text" rows="1"
						@input="form['c' + item] = $event.target.value.toUpperCase()"
						v-model="form['c' + item]"></textarea>
		</div>

	</div>
</div>

</template>

<script>
export default {
	props: ['form', 'qtdCs', 'categoria'],

	form: {
		qtdCs: this.qtdCs
	}

}
</script>



// WEBPACK FOOTER //
// src/views/followair/manutencao/cadastro/inspecao/components/cadastroCompleto.vue